import { Injectable,Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { MsalService } from '@azure/msal-angular';
import { Environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,private authMsalService: MsalService, @Inject(DOCUMENT) private document: Document) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const userID = this.authService.getUserId();
    const csrfToken = this.authService.getCsrfToken()
    const isPublicApi = localStorage.getItem('provisioned') == "1"
    let proxyUrl = Environment.msalConfig.auth.redirectUri
    let currentUrl = request.url
    if (isPublicApi) {
      let index = request.url.indexOf("api/")
      proxyUrl =  proxyUrl + request.url.substring(index)
    }

    if (request.url.includes('Authenticate') || request.url.includes('token')) {
      return next.handle(
        request.clone({
        url: isPublicApi ? proxyUrl : currentUrl,
        withCredentials: true
      }));
    } else {
      return next.handle(
        request.clone({
          url: isPublicApi ? proxyUrl : currentUrl,
          setHeaders: {
            ...(userID != null && {userid: `${userID}`}),
            ...(csrfToken != null && {'X-CSRF-Token': csrfToken})

          },
          withCredentials: true,
        })
      ).pipe(switchMap((event: HttpEvent<any>) => this.handleResponse(event, request))).pipe(catchError((err:HttpErrorResponse) => {
        if (err.status == 510) {
        this.onLogOut()

        }
        return throwError(() => err)
      }));
    }

    // return next.handle(request);
  }

  // intercept(
  //   request: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {
  //   const jwt = this.authService.getToken();
  //   const userID = this.authService.getUserId();
  //   const csrfToken = this.authService.getCsrfToken()
  //   if (request.url.includes('Authenticate') || request.url.includes('token')) {
  //     return next.handle(request);
  //   } else {
  //     return next.handle(
  //       request.clone({
  //         setHeaders: {
  //           authorization: `Bearer ${jwt}`,
  //           userid: `${userID}`,
  //           'X-CSRF-Token': csrfToken?.toString() || ''

  //         },
  //       })
  //     ).pipe(switchMap((event: HttpEvent<any>) => this.handleResponse(event, request)));
  //   }

  //   // return next.handle(request);
  // }

  
  private handleResponse(event: HttpEvent<any>, req: HttpRequest<any>): Observable<HttpEvent<any>> {
    if (event instanceof HttpResponse) { 
      const responseBody = event.body;

      if (responseBody && responseBody.statusCode && responseBody.statusCode === 510) {
        this.onLogOut()
      }
    }

    return new Observable<HttpEvent<any>>(observer => {
      observer.next(event);
      observer.complete();
    });
  }

  private onLogOut() {
    if (localStorage.getItem('isMsal') && localStorage.getItem('php') != "true") {
      localStorage.clear();
      sessionStorage.clear();
      this.authMsalService.logoutRedirect({ postLogoutRedirectUri: '/' });
    } else if (localStorage.getItem('php') == "true") {
      localStorage.clear();
      sessionStorage.clear();
      this.document.location.href = Environment.phpConfig.auth.logoutUri
    } else {
      let uaepasssignouturl = `${Environment.uaePassConfig.url}logout?redirect_uri=${Environment.uaePassConfig.redirect_url}`;
      localStorage.clear();
      sessionStorage.clear();
      this.authService.logout();
      this.document.location.href = uaepasssignouturl;
      //this.route.navigate(['/login'])
    }
  }
}
